import { render, staticRenderFns } from "./SectionRegistrationForm.vue?vue&type=template&id=66130d95&"
import script from "./SectionRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./SectionRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./SectionRegistrationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports